import { ChevronRight } from "lucide-react";
import React from "react";
import Flex from "@/components/layout/Flex";
import Typography from "@/components/shared/Typography";
import Button from "@/components/ui/Button";
import Drawer from "@/components/ui/Drawer";
import { getIndustries } from "@/content/helpers";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { IndustriesSlideProps } from "../types";
import Slide from "./slide";

const INDUSTRIES = getIndustries();
export const INDUSTRIES_SLIDE_INDEX = 20;

function IndustriesSlide({
  index = INDUSTRIES_SLIDE_INDEX,
  goToSlide,
  className,
  ...props
}: IndustriesSlideProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <Slide index={index} className={cn(className, classes)} {...native}>
      <Flex.Row className="relative w-full" justify="between" items="center">
        <Button.Icon
          className="absolute left-0 border-foreground"
          icon="arrow-left"
          variant="outline"
          onClick={() => goToSlide(0)}
          aria-label="Go Back"
        />

        <Typography.H2 className="w-full flex flex-1 justify-center items-center">
          Services
        </Typography.H2>
      </Flex.Row>

      {INDUSTRIES.map(item => (
        <Drawer.Close key={item.key} asChild>
          <Button.Link
            href={item.href}
            variant="ghost"
            className="w-full h-auto flex flex-row justify-between items-center rounded-none border-foreground border-b-2"
            aria-label={`Go to the ${item.label} Page`}
          >
            <Flex.Column justify="start" items="start">
              <Typography.Small className="text-left text-sm leading-none font-medium w-full">
                {item.label}
              </Typography.Small>

              <Typography.Small className="text-left text-muted-foreground line-clamp-2 text-sm leading-snug w-full">
                {item.description}
              </Typography.Small>
            </Flex.Column>
            <ChevronRight />
          </Button.Link>
        </Drawer.Close>
      ))}
    </Slide>
  );
}

export default IndustriesSlide;
